//@ts-nocheck
import {InfiniteScrollSentinel} from '@common/ui/infinite-scroll/infinite-scroll-sentinel';
import {Fragment, useEffect, useMemo, useState} from 'react';
import {ChannelContentProps} from '@app/channels/channel-content';
import {useInfiniteChannelContent} from '@common/channels/requests/use-infinite-channel-content';
import {ChannelHeader} from '@app/channels/channel-header/channel-header';
import {
  ContentGridLayout,
  ContentGridProps,
} from '@app/channels/content-grid/content-grid-layout';
import {ChannelContentGridItem} from '@app/channels/content-grid/channel-content-grid-item';
import {ChannelContentModel} from '@app/admin/channels/channel-content-config';
import {useChannelContent} from '@common/channels/requests/use-channel-content';
import clsx from 'clsx';
import {
  PaginationControls,
  PaginationControlsType,
} from '@common/ui/navigation/pagination-controls';
import {AdHost} from '@common/admin/ads/ad-host';
import {useTitleIndexFilters} from '@app/titles/use-title-index-filters';
import {Trans} from '@common/i18n/trans';
import {
  Box,
  FormControlLabel,
  Input,
  Select,
  Slider,
  SliderThumb,
  Typography,
} from '@mui/material';
import {useBackendFilterUrlParams} from '@common/datatable/filters/backend-filter-url-params';
import {useSettings} from '@common/core/settings/use-settings';
import {useAuth} from '@common/auth/use-auth';
import dot from 'dot-object';
import {Button} from '@common/ui/buttons/button';
import {ArrowSwapHorizontal, ArrowUp, ArrowUp2, Setting4} from 'iconsax-react';
import {Filter1Icon} from '@common/icons/material/Filter1';
import {TuneIcon} from '@common/icons/material/Tune';
import {useLocation} from 'react-router-dom';
import {TitlesDatatableFilters} from '@app/admin/titles/titles-datatable-filters';
import {TextField} from '@common/ui/forms/input-field/text-field/text-field';
import {
  DatePicker,
  FormDatePicker,
} from '@common/ui/forms/input-field/date/date-picker/date-picker';
import useDelay from './useDelay';

interface AirbnbThumbComponentProps extends React.HTMLAttributes<unknown> {}

function AirbnbThumbComponent(props: AirbnbThumbComponentProps) {
  const {children, ...other} = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

interface ChannelContentGridProps extends ChannelContentProps {
  variant?: ContentGridProps['variant'];
}
export function ChannelContentGrid(props: ChannelContentGridProps) {
  const {isLoggedIn} = useAuth();

  const certificationGroups = [
    {display: '+3', variants: ['tv-y', 'tv-g', 'y7', 'tv-y7', 'tv-y7-f7', 'g']},
    {display: '+7', variants: ['7', '+7', '7+']},
    {display: '+10', variants: ['pg']},
    {display: '+13', variants: ['13', 'pg-13', 'y']},
    {display: '+14', variants: ['14', 'tv-14']},
    {display: '+15', variants: ['ma']},
    {display: '+16', variants: ['+16', '16']},
    {display: '+18', variants: ['nc-17', 'tv-ma', 'r', '+18']},
    {
      display: 'Not Rated',
      variants: ['m/pg', 'nr', 'not rated', 'notrated', 'unrated', 'gp'],
    },
    {display: 'Approved', variants: ['approved', 'passed', 'Approved']},
  ];

  const pathname = useLocation().pathname;

  const thisYear = new Date().getFullYear();
  const {filters, filtersLoading} = useTitleIndexFilters();

  const groupMap = certificationGroups.reduce((map, group) => {
    group.variants.forEach(variant => (map[variant] = group.display));
    return map;
  }, {});

  const groupedData = filters
    .find(item => item.key === 'certification')
    ?.control.options?.reduce((acc, item) => {
      const groupKey = groupMap[item.key.toLowerCase()];
      if (groupKey) {
        acc[groupKey] = acc[groupKey] || [];
        acc[groupKey].push(item);
      }
      return acc;
    }, {});

  const groupedArray = Object.entries(groupedData).map(([display, items]) => ({
    display,
    items,
  }));

  const {decodedFilters, encodedFilters, replaceAll} =
    useBackendFilterUrlParams(filters);

  const [openMobileOffcanvas, setOpenMobileOffCanvas] =
    useState<boolean>(false);
  const [selectedYears, setSelectedYears] = useState<number[]>([
    1900,
    thisYear,
  ]);
  const [selectedAges, setSelectedAges] = useState<number[]>([1, 120]);
  const [selectedRatings, setSelectedRatings] = useState<number[]>([1, 10]);
  const [selectedRuntimes, setSelectedRuntimes] = useState<number[]>([1, 400]);
  const [ttValue, setTtValue] = useState<string>('');

  const delayedValue = useDelay(ttValue);

  useEffect(() => {
    if (!ttValue && !!decodedFilters.find(item => item.key === 'imdb_id')) {
      replaceAll([]);
    } else {
      replaceAll([
        {
          key: 'imdb_id',
          operator: '=',
          value: delayedValue,
        },
      ]);
    }
  }, [delayedValue]);

  // console.log(groupedArray);
  // console.log(decodedFilters);

  const isInfiniteScroll =
    !props.isNested &&
    (!props.channel.config.paginationType ||
      props.channel.config.paginationType === 'infiniteScroll');
  return (
    <div dir="rtl" className="flex justify-between gap-x-50 max-md:gap-x-10">
      <div
        className="fixed bottom-10 right-20 z-50 cursor-pointer rounded-lg bg-[#AA4A44]"
        onClick={() => window.scrollTo(0, 0)}
      >
        <ArrowUp2 size={40} className="text-white" />
      </div>
      <div className="w-full">
        <div className="flex items-center justify-between">
          <ChannelHeader {...props} />
          {/* {pathname.includes('people') ? null : ( */}
          <TuneIcon
            className="mb-20 mt-90 md:hidden"
            size="md"
            color="#ddd"
            onClick={() => {
              setOpenMobileOffCanvas(true);
            }}
          />
          {/* )} */}
        </div>
        {isInfiniteScroll ? (
          <InfiniteScrollGrid {...props} />
        ) : (
          <PaginatedGrid {...props} />
        )}
      </div>
      {openMobileOffcanvas && (
        <div
          className="fixed left-0 right-0 top-0 z-10 h-screen w-screen bg-black/50"
          onClick={() => setOpenMobileOffCanvas(false)}
        />
      )}
      {!isLoggedIn ? null : pathname.includes('people') ? (
        <div
          className={clsx(
            'sticky top-80 mb-20 mt-90 max-h-[calc(100vh-100px)] min-w-[300px] max-w-[20%] overflow-y-auto overflow-x-hidden px-20 transition-all max-md:fixed max-md:top-80 max-md:z-50 max-md:mb-0 max-md:mt-0 max-md:max-h-[calc(100vh-80px)] max-md:max-w-[300px] max-md:bg-black max-md:p-20 md:mb-40',
            openMobileOffcanvas ? 'left-0' : 'max-md:-translate-x-[200%]',
          )}
        >
          <div className="flex items-center justify-between">
            <p className="m-0 font-bold">
              <Trans message="Filters" />
            </p>
            {decodedFilters.length !== 0 && (
              <Button
                className="border"
                onClick={() => {
                  setSelectedRatings([1, 10]);
                  setSelectedRuntimes([1, 400]);
                  setSelectedYears([1900, thisYear]);
                  setSelectedAges([1, 120]);
                  replaceAll([]);
                }}
              >
                <Trans message="Reset Filters" />
              </Button>
            )}
          </div>
          <hr className="h-1" />
          <p>
            <Trans message="Person Age" />
          </p>
          <Slider
            slots={{thumb: AirbnbThumbComponent}}
            sx={{
              color: '#AA4A44',
              '& .MuiSlider-thumb': {
                height: 27,
                width: 27,
                backgroundColor: '#313131',
                border: '1px solid currentColor',
                borderRadius: 0,
                '&:hover': {
                  boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
                },
                '& .airbnb-bar': {
                  height: 9,
                  width: '1px',
                  backgroundColor: '#AA4A44',
                  marginLeft: '1px',
                  marginRight: '1px',
                },
              },
            }}
            min={1}
            max={120}
            value={selectedAges}
            onChangeCommitted={(e, value) => {
              const decodeFil = [...decodedFilters];
              const findReleaseIndex = decodedFilters.findIndex(
                item => item.key === 'birth_date',
              );
              if (findReleaseIndex === -1) {
                decodeFil.push({
                  key: 'birth_date',
                  operator: 'between',
                  value: {
                    start: `${Number(thisYear) - value[1]}-01-01 00:00:00`,
                    end: `${Number(thisYear) - value[0]}-01-01 00:00:00`,
                  },
                });
              } else {
                decodeFil[findReleaseIndex].value = {
                  start: `${Number(thisYear) - value[1]}-01-01 00:00:00`,
                  end: `${Number(thisYear) - value[0]}-01-01 00:00:00`,
                };
              }
              replaceAll(decodeFil);
            }}
            onChange={(e, val) => {
              setSelectedAges(val as number[]);
            }}
            valueLabelDisplay="auto"
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span className="text-base">{selectedAges[1]}</span>
            <ArrowSwapHorizontal size="24" color="#ddd" />
            <span className="text-base">{selectedAges[0]}</span>
          </Box>
          <hr className="h-1" />
          <p>
            <Trans message="Gender" />
          </p>
          <div className="flex w-full flex-col gap-y-10">
            <select
              className="cursor-pointer border px-3 py-2"
              defaultValue={
                decodedFilters.find(fil => fil.key === 'language')?.value
              }
              value={decodedFilters.find(fil => fil.key === 'language')?.value}
              onChange={e => {
                const decodeFil = [...decodedFilters];
                const findLanguageIndex = decodedFilters.findIndex(
                  item => item.key === 'gender',
                );
                if (findLanguageIndex === -1) {
                  if (e.target.value === 'all') return;
                  decodeFil.push({
                    key: 'gender',
                    operator: '=',
                    value: e.target.value,
                    valueKey: e.target.value,
                  });
                } else {
                  decodeFil[findLanguageIndex].value = e.target.value;
                  decodeFil[findLanguageIndex].valueKey = e.target.value;
                  if (e.target.value === 'all') {
                    decodeFil.splice(findLanguageIndex, 1);
                  }
                }
                replaceAll(decodeFil);
              }}
            >
              <option value="all">
                <Trans message="All Genders" />
              </option>
              <option value={'male'}>
                <Trans message={'Male'} />
              </option>{' '}
              <option value={'female'}>
                <Trans message={'Female'} />
              </option>
            </select>{' '}
          </div>
          <hr className="h-1" />
          <p>
            <Trans message="Place of Birth" />
          </p>
          <div className="flex w-full flex-col gap-y-1">
            <select
              className="cursor-pointer border px-3 py-2"
              defaultValue={
                decodedFilters.find(fil => fil.key === 'birth_place')?.value
              }
              value={
                decodedFilters.find(fil => fil.key === 'birth_place')?.value
              }
              onChange={e => {
                const decodeFil = [...decodedFilters];
                const findCountryIndex = decodedFilters.findIndex(
                  item => item.key === 'birth_place',
                );
                if (findCountryIndex === -1) {
                  if (e.target.value === 'all') return;
                  console.log(e.target.value);

                  decodeFil.push({
                    key: 'birth_place',
                    operator: 'like',
                    value: e.target.value,
                    // value: "Santiago, Chile",
                  });
                } else {
                  decodeFil[findCountryIndex].value = e.target.value;
                  if (e.target.value === 'all') {
                    decodeFil.splice(findCountryIndex, 1);
                  }
                }
                replaceAll(decodeFil);
              }}
            >
              <option value="all">
                <Trans message="All Countries" />
              </option>
              {filters
                .find(item => item.key === 'productionCountries')
                ?.control.options?.map(item => (
                  <option value={`% ${item.label.message}%`}>
                    <Trans message={item.label.message} />
                  </option>
                ))}
            </select>
          </div>
        </div>
      ) : (
        <div
          className={clsx(
            'sticky top-80 mb-20 mt-90 max-h-[calc(100vh-100px)] min-w-[300px] max-w-[20%] overflow-y-auto overflow-x-hidden px-20 transition-all max-md:fixed max-md:top-80 max-md:z-50 max-md:mb-0 max-md:mt-0 max-md:max-h-[calc(100vh-80px)] max-md:max-w-[300px] max-md:bg-black max-md:p-20 md:mb-40',
            openMobileOffcanvas ? 'left-0' : 'max-md:-translate-x-[200%]',
          )}
        >
          <div className="flex items-center justify-between">
            <p className="m-0 font-bold">
              <Trans message="Filters" />
            </p>
            {decodedFilters.length !== 0 && (
              <Button
                className="border"
                onClick={() => {
                  setSelectedRatings([1, 10]);
                  setSelectedRuntimes([1, 400]);
                  setSelectedYears([1900, thisYear]);
                  replaceAll([]);
                }}
              >
                <Trans message="Reset Filters" />
              </Button>
            )}
          </div>
          {!pathname.includes('titles') ? null : (
            <Fragment>
              <hr className="h-1" />
              <div className="flex w-full flex-col gap-y-1">
                <p>
                  <Trans message="Type" />
                </p>
                <select
                  className="cursor-pointer border px-3 py-2"
                  onChange={e => {
                    const decodeFil = [...decodedFilters];
                    const findCountryIndex = decodedFilters.findIndex(
                      item => item.key === 'is_series',
                    );
                    if (findCountryIndex === -1) {
                      decodeFil.push({
                        key: 'is_series',
                        operator: '=',
                        value: e.target.value,
                      });
                    } else {
                      decodeFil[findCountryIndex].value = e.target.value;
                    }
                    replaceAll(decodeFil);
                  }}
                >
                  {TitlesDatatableFilters?.find(
                    item => item.key === 'is_series',
                  )?.control?.options?.map(opt => (
                    <option
                      value={
                        opt?.label?.message === 'both' ? opt.key : opt.value
                      }
                    >
                      {opt?.label?.message}
                    </option>
                  ))}
                </select>
              </div>
            </Fragment>
          )}
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-10">
            <p className="m-0">
              <Trans message="Search By Imdb Id" />
            </p>
            <form
              action=""
              onSubmit={e => {
                e.preventDefault();
                if (
                  !ttValue &&
                  !!decodedFilters.find(item => item.key === 'imdb_id')
                ) {
                  replaceAll([]);
                } else {
                  replaceAll([
                    {
                      key: 'imdb_id',
                      operator: '=',
                      value: ttValue,
                    },
                  ]);
                }
              }}
            >
              <TextField
                inputClassName="!outline-[#AA4A44] !text-left"
                onChange={e => setTtValue(e.target.value)}
              />
            </form>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1">
            <p className="m-0">
              <Trans message="Genres" />
            </p>
            <div className="flex max-h-[400px] w-full flex-col overflow-y-auto overflow-x-hidden">
              {filters
                .find(item => item.key === 'genres')
                ?.control.options?.map(gen => (
                  <FormControlLabel
                    className="my-1 !mr-0 !flex !items-center gap-x-12 px-2 py-2 text-lg transition-colors hover:bg-white/20"
                    control={
                      <input
                        defaultChecked={decodedFilters
                          .find(fil => fil.key === 'genres')
                          ?.value.includes(gen.value)}
                        checked={decodedFilters
                          .find(fil => fil.key === 'genres')
                          ?.value.includes(gen.value)}
                        type="checkbox"
                        className="h-18 w-18 !rounded-lg accent-[#AA4A44] !outline-1"
                        style={{outlineStyle: 'solid'}}
                      />
                    }
                    label={
                      <span className="font-sans font-semibold">
                        <Trans message={gen.label.message} />
                      </span>
                    }
                    onChange={e => {
                      const decodeFil = [...decodedFilters];
                      const findGenreIndex = decodedFilters.findIndex(
                        item => item.key === 'genres',
                      );
                      if (findGenreIndex === -1) {
                        decodeFil.push({
                          key: 'genres',
                          value: [gen.value],
                          operator: 'hasAll',
                        });
                      } else {
                        const foundValue = decodeFil[findGenreIndex].value;
                        if (foundValue?.includes(gen.value)) {
                          const findValueIndex = foundValue.findIndex(
                            val => val === gen.value,
                          );
                          foundValue.splice(findValueIndex, 1);
                        } else {
                          foundValue.push(gen.value);
                        }
                        if (foundValue.length === 0) {
                          decodeFil.splice(findGenreIndex, 1);
                        } else {
                          decodeFil[findGenreIndex].value = foundValue;
                        }
                      }
                      replaceAll(decodeFil);
                    }}
                  />
                ))}
            </div>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1 max-md:px-4">
            <p>
              <Trans message="Release Date" />
            </p>
            <Slider
              slots={{thumb: AirbnbThumbComponent}}
              sx={{
                color: '#AA4A44',
                '& .MuiSlider-thumb': {
                  height: 27,
                  width: 27,
                  backgroundColor: '#313131',
                  border: '1px solid currentColor',
                  borderRadius: 0,
                  '&:hover': {
                    boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
                  },
                  '& .airbnb-bar': {
                    height: 9,
                    width: '1px',
                    backgroundColor: '#AA4A44',
                    marginLeft: '1px',
                    marginRight: '1px',
                  },
                },
              }}
              min={1900}
              max={thisYear}
              value={selectedYears}
              onChangeCommitted={(e, value) => {
                const decodeFil = [...decodedFilters];
                const findReleaseIndex = decodedFilters.findIndex(
                  item => item.key === 'release_date',
                );
                if (findReleaseIndex === -1) {
                  decodeFil.push({
                    key: 'release_date',
                    operator: 'between',
                    value: {
                      start: value[0].toString(),
                      end: value[1].toString(),
                    },
                  });
                } else {
                  decodeFil[findReleaseIndex].value = {
                    start: value[0].toString(),
                    end: value[1].toString(),
                  };
                }
                replaceAll(decodeFil);
              }}
              onChange={(e, val) => {
                setSelectedYears(val as number[]);
              }}
              valueLabelDisplay="auto"
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span className="text-base">{selectedYears[1]}</span>
              <ArrowSwapHorizontal size="24" color="#ddd" />
              <span className="text-base">{selectedYears[0]}</span>
            </Box>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1 max-md:px-4">
            <p>
              <Trans message="Rating" />
            </p>
            <Slider
              slots={{thumb: AirbnbThumbComponent}}
              sx={{
                color: '#AA4A44',
                '& .MuiSlider-thumb': {
                  height: 27,
                  width: 27,
                  backgroundColor: '#313131',
                  border: '1px solid currentColor',
                  borderRadius: 0,
                  '&:hover': {
                    boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
                  },
                  '& .airbnb-bar': {
                    height: 9,
                    width: '1px',
                    backgroundColor: '#AA4A44',
                    marginLeft: '1px',
                    marginRight: '1px',
                  },
                },
              }}
              min={1}
              max={10}
              step={0.1}
              value={selectedRatings}
              onChangeCommitted={(e, value) => {
                const decodeFil = [...decodedFilters];
                const findRatingIndex = decodedFilters.findIndex(
                  item => item.key === 'tmdb_vote_average',
                );
                if (findRatingIndex === -1) {
                  decodeFil.push({
                    key: 'tmdb_vote_average',
                    operator: 'between',
                    value: {
                      start: value[0].toString(),
                      end: value[1].toString(),
                    },
                  });
                } else {
                  decodeFil[findRatingIndex].value = {
                    start: value[0].toString(),
                    end: value[1].toString(),
                  };
                }
                replaceAll(decodeFil);
              }}
              onChange={(e, val) => {
                setSelectedRatings(val as number[]);
              }}
              valueLabelDisplay="auto"
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span className="text-base">{selectedRatings[1]}</span>
              <ArrowSwapHorizontal size="24" color="#ddd" />
              <span className="text-base">{selectedRatings[0]}</span>
            </Box>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1 max-md:px-4">
            <p>
              <Trans message="Runtime" />
            </p>
            <Slider
              slots={{thumb: AirbnbThumbComponent}}
              sx={{
                color: '#AA4A44',
                '& .MuiSlider-thumb': {
                  height: 27,
                  width: 27,
                  backgroundColor: '#313131',
                  border: '1px solid currentColor',
                  borderRadius: 0,
                  marginRight: 10,
                  '&:hover': {
                    boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
                  },
                  '& .airbnb-bar': {
                    height: 9,
                    width: '1px',
                    backgroundColor: '#AA4A44',
                    marginLeft: '1px',
                    marginRight: '1px',
                  },
                },
              }}
              min={1}
              max={400}
              step={1}
              value={selectedRuntimes}
              onChangeCommitted={(e, value) => {
                const decodeFil = [...decodedFilters];
                const findRuntimeIndex = decodedFilters.findIndex(
                  item => item.key === 'runtime',
                );
                if (findRuntimeIndex === -1) {
                  decodeFil.push({
                    key: 'runtime',
                    operator: 'between',
                    value: {
                      start: value[0].toString(),
                      end: value[1].toString(),
                    },
                  });
                } else {
                  decodeFil[findRuntimeIndex].value = {
                    start: value[0].toString(),
                    end: value[1].toString(),
                  };
                }
                replaceAll(decodeFil);
              }}
              onChange={(e, val) => {
                setSelectedRuntimes(val as number[]);
              }}
              valueLabelDisplay="auto"
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span className="text-base">
                {selectedRuntimes[1]}
                <span className="mx-1">
                  <Trans message="min" />
                </span>{' '}
              </span>
              <ArrowSwapHorizontal size="24" color="#ddd" />
              <span className="text-base">
                {selectedRuntimes[0]}
                <span className="mx-1">
                  <Trans message="min" />
                </span>
              </span>
            </Box>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1">
            <p>
              <Trans message="Country" />
            </p>
            <select
              className="cursor-pointer border px-3 py-2"
              defaultValue={
                decodedFilters.find(fil => fil.key === 'productionCountries')
                  ?.value
              }
              value={
                decodedFilters.find(fil => fil.key === 'productionCountries')
                  ?.value
              }
              onChange={e => {
                const decodeFil = [...decodedFilters];
                const findCountryIndex = decodedFilters.findIndex(
                  item => item.key === 'productionCountries',
                );
                if (findCountryIndex === -1) {
                  if (e.target.value === 'all') return;
                  decodeFil.push({
                    key: 'productionCountries',
                    operator: 'hasAll',
                    value: [Number(e.target.value)],
                  });
                } else {
                  decodeFil[findCountryIndex].value = [Number(e.target.value)];
                  if (e.target.value === 'all') {
                    decodeFil.splice(findCountryIndex, 1);
                  }
                }
                replaceAll(decodeFil);
              }}
            >
              <option value="all">
                <Trans message="All Countries" />
              </option>
              {filters
                .find(item => item.key === 'productionCountries')
                ?.control.options?.map(item => (
                  <option value={item.value}>
                    <Trans message={item.label.message} />
                  </option>
                ))}
            </select>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1">
            <p>
              <Trans message="Language" />
            </p>
            <select
              className="cursor-pointer border px-3 py-2"
              defaultValue={
                decodedFilters.find(fil => fil.key === 'language')?.value
              }
              value={decodedFilters.find(fil => fil.key === 'language')?.value}
              onChange={e => {
                const decodeFil = [...decodedFilters];
                const findLanguageIndex = decodedFilters.findIndex(
                  item => item.key === 'language',
                );
                if (findLanguageIndex === -1) {
                  if (e.target.value === 'all') return;
                  decodeFil.push({
                    key: 'language',
                    operator: '=',
                    value: e.target.value,
                    valueKey: e.target.value,
                  });
                } else {
                  decodeFil[findLanguageIndex].value = e.target.value;
                  decodeFil[findLanguageIndex].valueKey = e.target.value;
                  if (e.target.value === 'all') {
                    decodeFil.splice(findLanguageIndex, 1);
                  }
                }
                replaceAll(decodeFil);
              }}
            >
              <option value="all">
                <Trans message="All Languages" />
              </option>
              {filters
                .find(item => item.key === 'language')
                ?.control.options?.map((item, index) => (
                  <option key={index} value={item.value}>
                    <Trans message={item.label.message} />
                  </option>
                ))}
            </select>
          </div>
          <hr className="h-1" />
          <div className="flex w-full flex-col gap-y-1">
            <p>
              <Trans message="Certification" />
            </p>
            <div className="flex flex-wrap">
              {groupedArray.map(item => (
                <div
                  className={clsx(
                    'cursor-pointer border p-1',
                    decodedFilters.some(f => f.key === 'certification')
                      ? decodedFilters[
                          decodedFilters.findIndex(
                            f => f.key === 'certification',
                          )
                        ].value[0] === item.items[0].value
                        ? 'bg-white/50'
                        : ''
                      : '',
                  )}
                  onClick={() => {
                    const decodeFil = [...decodedFilters];
                    const findCertificationIndex = decodedFilters.findIndex(
                      item => item.key === 'certification',
                    );
                    if (findCertificationIndex === -1) {
                      decodeFil.push({
                        key: 'certification',
                        operator: '=',
                        value: item.items.map(cert => cert.value),
                        valueKey: item.items.map(cert => cert.value),
                      });
                    } else {
                      decodeFil[findCertificationIndex].value = item.items.map(
                        cert => cert.value,
                      );
                      decodeFil[findCertificationIndex].valueKey =
                        item.items.map(cert => cert.value);
                    }
                    replaceAll(decodeFil);
                  }}
                >
                  <Trans message={item.display} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function InfiniteScrollGrid({channel, variant}: ChannelContentGridProps) {
  const query = useInfiniteChannelContent<ChannelContentModel>(channel);
  return (
    <div
      className={clsx('transition-opacity', query.isReloading && 'opacity-70')}
    >
      <ContentGrid content={query.items} variant={variant} />
      <InfiniteScrollSentinel query={query} />
    </div>
  );
}

function PaginatedGrid({channel, variant, isNested}: ChannelContentGridProps) {
  const shouldPaginate = !isNested;
  const query = useChannelContent(channel, null, {paginate: shouldPaginate});
  return (
    <div
      className={clsx(
        'transition-opacity',
        query.isPlaceholderData && 'opacity-70',
      )}
    >
      {shouldPaginate && (
        <PaginationControls
          pagination={query.data}
          type={channel.config.paginationType as PaginationControlsType}
          className="mb-24"
        />
      )}
      <ContentGrid content={query.data?.data} variant={variant} />
      {shouldPaginate && (
        <PaginationControls
          pagination={query.data}
          type={channel.config.paginationType as PaginationControlsType}
          className="mt-24"
          scrollToTop
        />
      )}
    </div>
  );
}

interface ContentProps {
  content: ChannelContentModel[] | undefined;
  variant: ContentGridProps['variant'];
}
export function ContentGrid({content = [], variant}: ContentProps) {
  const settings = useSettings();
  const {isSubscribed} = useAuth();
  const adCode = useMemo(() => {
    return dot.pick(`ads.general_top`, settings);
  }, [settings]);

  return (
    <ContentGridLayout variant={variant} className="custom-box z-50 text-white">
      {content.map((item, index) => (
        <Fragment key={`${item.id}-${item.model_type}`}>
          {settings.ads?.disable || isSubscribed || !adCode
            ? null
            : index % 13 === 0 && (
                <AdHost
                  slot="general_top"
                  className="col-span-5 my-10 max-h-[290px] max-lg:col-span-3 max-md:col-span-2"
                />
              )}
          <ChannelContentGridItem item={item} variant={variant} />
        </Fragment>
      ))}
    </ContentGridLayout>
  );
}
